import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import {
	Avatar,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	DialogContent,
	Typography,
	useTheme,
	Link,
	Icon,
	Checkbox,
	Chip
} from '@material-ui/core'
import { AccountCircle, Check } from '@material-ui/icons'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles'
import { getAvatarLetters, getChipStyles } from '../../services/helpers'
import { removeAccount } from '../../actions/checkIns/checkins.actions'
import { useSelector, useDispatch } from 'react-redux'
import LoadingOverlay from '../Misc/LoadingOverlay'
const useStyles = makeStyles((theme) => ({
	close: {
		position: 'absolute',
		color: '#777679',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		cursor: 'pointer'
	},

	descriptor: {
		fontSize: '16px',
		fontWeight: '550',

		'& i': {
			fontSize: '20px',
			marginLeft: '17px',
			marginRight: '8px',
			color: '#6B4AD6',
			lineHeight: '20px'
		}
	},

	descriptors: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'wrap'
	},
	dialog: {
		'& .MuiDialog-paper': {
			width: 450
		}
	},
	dialogActions: {
		justifyContent: 'flex-start',
		paddingTop: '16px'

		// borderTop: "1px solid #D0CFD2"
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 20
	},

	friend: {
		display: 'flex',
		flexDirection: 'row',
		margin: 10
	},

	friendAvatar: {
		height: '38px'
	},
	friendName: {
		fontSize: '16px',
		fontWeight: '550',
		margin: '8px'
	},

	h6: {
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		margin: 16
	},

	line: {
		marginTop: '8px',
		marginBottom: 8,
		height: 1,
		border: '1px solid #D0CFD2'
	},

	noteBody: {
		margin: 14,
		fontSize: 14,
		width: 424
	},

	petRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
		'& img': {
			height: 50,
			width: 50,
			borderRadius: 25,
			marginRight: 15
		},
		'& h4': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16,
			padding: 16
		}
	},

	reportHeader: {
		'& h2': {
			textTransform: 'uppercase',
			fontWeight: '800',
			fontSize: '16px !important'
		}
	},

	reportPreview: {
		//overflowY: "scroll",
		display: 'flex',
		flexDirection: 'row',
		paddingTop: 15
	},

	report: {
		display: 'flex',
		flexDirection: 'column'
	},

	reportItem: {
		minHeight: 100,
		height: 'auto',
		width: 500,
		background: '#F9F9F9',
		marginRight: 8,
		marginTop: 8,
		marginBottom: 8,
		borderRadius: '6px'
	},

	reportPictures: {
		marginLeft: 12,
		width: 350,
		minHeight: 396,
		height: 'auto',
		borderRadius: '6px',
		background: '#F9F9F9',
		display: 'flex',
		flexDirection: 'column'
	},

	pictureHolder: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		display: 'flex',
		margin: 12,
		marginTop: 0
	},

	picture: {
		width: 155,
		height: 155,
		margin: 4,
		border: '1px solid #D0CFD2',
		borderRadius: '10px'
	},
	visitorContainer: {
		// border: "1px solid black",
		display: 'flex',
		flexDirection: 'column',
		paddingBottom: '24'
	},
	visitor: {
		marginBottom: '16px',
		// height: "88px",
		//border: "1px solid red",
		background: '#F9F9F9',
		borderRadius: '6px',
		display: 'flex',
		flexDirection: 'row'
	},
	visitorPicture: {
		width: '88px',
		height: '88px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '6px 0px 0px 0px',
		overflow: 'hidden'
		// border: "1px solid black"
	},
	visitorPictureGuest: {
		width: '88px',
		height: '88px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '6px 0px 0px 6px',
		overflow: 'hidden',
		backgroundColor: '#BBBDF9'
		// border: "1px solid black"
	},
	guestText: {
		fontSize: 16,
		fontWeight: '800',
		color: '#FFFFFF'
	},
	pic: {
		height: '100%',
		width: '100%'
	},
	vistorDetails: {
		height: 88,
		// margin: "16px",
		paddingLeft: 16,
		width: 'auto',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: 220
	},
	visitorEligibility: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		paddingTop: 8
	},
	eligibilityText: {
		color: '#4D4C4F',
		fontSize: 12,
		fontWeight: '800',
		letterSpacing: 0.75
	},
	vistorName: {
		display: 'flex',
		alignItems: 'center',
		paddingTop: '0px'
	},
	vistorRemove: {
		display: 'flex',
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		paddingRight: 16,
		alignItems: 'center'
	},
	vistorSubtitle: {
		paddingTop: '0px',
		color: '#777679',
		fontSize: '14px',
		fontWeight: '600'
	}
}))

const DeleteHoliday = (props) => {
	const theme = useTheme()
	const classes = useStyles(theme)
	const dispatch = useDispatch()

	let { isShown, setIsShown, deleteHoliday } = props

	const getActions = () => {
		// if (checkIn.checked_in) return null;
		return (
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="solid"
					color="secondary"
					style={{
						padding: '15px',
						paddingTop: '5px',
						paddingBottom: '5px',
						backgroundColor: '#D02C2C',
						color: '#FFFFFF',
						borderRadius: 19,
						marginRight: 16
					}}
					onClick={() => {
						deleteHoliday()
					}}>
					CONFIRM
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		)
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{ style: { width: 450, maxWidth: 450 } }}>
			<DialogTitle className={classes.reportHeader}>DELETE HOLIDAY</DialogTitle>
			<DialogContent style={{ paddingTop: 16, paddingBottom: 16 }}>
				<Typography style={{ fontSize: 16 }}>
					All appointments that are already scheduled for this holiday will still be subject to the
					deposit, but any surcharge will be removed.
				</Typography>
			</DialogContent>
			{getActions()}
		</Dialog>
	)
}

export default DeleteHoliday
